import {dataGridSortMoney, dataGridSortNumber, dataGridSortText} from "../../utils/dataGridSorting.js";
import {useTranslation} from "react-i18next";
import {useRenderCurrencyValue, useRenderNumber, useRenderPercentValue} from "../../api/utilities/useValueRenderers.js";
import {useMemo} from "react";
import useUserSettings from "../../utils/useUserSettings.js";

export function useTopChannelColumns(project, isDaily) {
    let {t} = useTranslation();

    let renderPercentValue = useRenderPercentValue();
    let renderCurrencyValue = useRenderCurrencyValue();
    let renderNumber = useRenderNumber();

    let [userSettings] = useUserSettings();

    return useMemo(() => {
        let topChannelColumns = [];

        let useMarketing = userSettings?.isMarketing === true || isDaily;

        topChannelColumns.push({
            name: 'name',
            header: t('dashboard.channel'),
            defaultFlex: 1.75,
            sort: dataGridSortText,
        });

        topChannelColumns.push({
            name: 'spendMarketing',
            header: t('dashboard.grid.spend-marketing'),
            defaultFlex: 2,
            textAlign: 'end',
            minWidth: 120,
            sortable: false,
            render: (input) => renderCurrencyValue(input.data.spendMarketing, true),
            sort: dataGridSortMoney,
        });

        topChannelColumns.push({
            name: useMarketing ? 'turnoverGross' : 'turnoverNet',
            header: t('dashboard.turnover'),
            defaultFlex: 2,
            textAlign: 'end',
            minWidth: 100,
            sortable: false,
            render: (input) => renderCurrencyValue(
                useMarketing ? input.data.turnoverGross : input.data.turnoverNet,
                true
            ),
            sort: dataGridSortMoney,
        });

        topChannelColumns.push({
            name: useMarketing ? 'ordersGross' : 'ordersNet',
            header: t('dashboard.orders-short'),
            defaultFlex: 1.2,
            textAlign: 'end',
            render: (input) => renderNumber(
                useMarketing ? input.data.ordersGross : input.data.ordersNet
            ),
            sort: dataGridSortNumber,
        });

        topChannelColumns.push({
            name: useMarketing ? 'pnoGross' : 'pnoNet',
            header: t('dashboard.pno'),
            defaultFlex: 1.4,
            textAlign: 'end',
            sortable: false,
            render: (input) => renderPercentValue(
                useMarketing ? input.data.pnoGross : input.data.pnoNet
            ),
            sort: dataGridSortNumber,
        });

        return topChannelColumns;
    }, [project.id, isDaily, userSettings]);
}
